import {OnlyTwoParamsOptions} from '../../../components/grid-dx/types';
import authFetch from '../../../helpers/requests';
import {useSelector} from 'react-redux';

function useAddWith2ParamsOptions(url: string) {
  const token: string = useSelector(
    (state: any) => state.authentication.user.token,
  );
  return async (onlyTwoParamsOptions: OnlyTwoParamsOptions) => {
    var values = {
      ...onlyTwoParamsOptions.AddedOne,
      ...onlyTwoParamsOptions.AddedTwo,
    };
    try {
      const response = await authFetch(
        `${url}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify(JSON.stringify(values)),
        },
        token,
      );
      return response;
    } catch (e) {
      //¿¿Que hacemos con el error del POST??
      return {};
    }
  };
}

export default useAddWith2ParamsOptions;
